/*-----------------------------------------------------------------
- Home
-----------------------------------------------------------------*/

export default {
    title    : 'خانه',
    watch_now: 'شاهد الآن',
    discover : {
        link: 'يتعلم أكثر',
    },
    discover_power: {
        unlock_text: 'أطلق العنان لقوة البرامج المقطوعة الرأس',
        button     : 'نبدأ الآن!',
    },
    articles: {
        title   : 'أحدث المقالات',
        author  : 'نویسنده',
        see_blog: 'انظر المدونة',
        min_read: 'قراءة دقيقة',
    },
};
